/** CoStar.Api.AnalyticsDataCalculations.Interface.ViewModels.SliceGrouping */
export var SliceGrouping;
(function (SliceGrouping) {
    SliceGrouping[SliceGrouping["StarRatings"] = 0] = "StarRatings";
    SliceGrouping[SliceGrouping["College"] = 1] = "College";
    SliceGrouping[SliceGrouping["Hospitality"] = 2] = "Hospitality";
})(SliceGrouping || (SliceGrouping = {}));
/** CoStar.Api.AnalyticsDataCalculations.Interface.ViewModels.TimeframeIntervalValues */
export var TimeframeIntervalValues;
(function (TimeframeIntervalValues) {
    TimeframeIntervalValues[TimeframeIntervalValues["None"] = 0] = "None";
    TimeframeIntervalValues[TimeframeIntervalValues["OneYearYearlyInterval"] = 1] = "OneYearYearlyInterval";
    TimeframeIntervalValues[TimeframeIntervalValues["ThreeYearYearlyInterval"] = 3] = "ThreeYearYearlyInterval";
    TimeframeIntervalValues[TimeframeIntervalValues["OneYearQuarterlyInterval"] = 4] = "OneYearQuarterlyInterval";
    TimeframeIntervalValues[TimeframeIntervalValues["FiveYearYearlyInterval"] = 5] = "FiveYearYearlyInterval";
    TimeframeIntervalValues[TimeframeIntervalValues["ThreeYearQuarterlyInterval"] = 12] = "ThreeYearQuarterlyInterval";
    TimeframeIntervalValues[TimeframeIntervalValues["OneYearMonthlyInterval"] = 13] = "OneYearMonthlyInterval";
    TimeframeIntervalValues[TimeframeIntervalValues["FiveYearQuarterlyInterval"] = 20] = "FiveYearQuarterlyInterval";
    TimeframeIntervalValues[TimeframeIntervalValues["ThreeYearMonthlyInterval"] = 36] = "ThreeYearMonthlyInterval";
    TimeframeIntervalValues[TimeframeIntervalValues["FiveYearMonthlyInterval"] = 60] = "FiveYearMonthlyInterval";
})(TimeframeIntervalValues || (TimeframeIntervalValues = {}));
